export class BiondMealGlobalEvents {

    constructor(biondInterface, biondMealGlobalInterface) {

        this.biondInterface = biondInterface;
        this.biondMealGlobalInterface = biondMealGlobalInterface;
        this.container = document.querySelector('.meal-selection-section');
    }

    init() {
        if (!this.container) {
            console.warn('❌ Kein Container für Events gefunden.');
            return;
        }

        this.initGlobalEvents();

        // 🌱 Pflanzenzähler-Popup bei Klick außerhalb schließen
        document.addEventListener('click', (e) => {
            const popup = document.getElementById('plant-counter-popup');
            if (!popup?.classList.contains('open')) return;
            if (e.target.closest('#plant-counter')) return;
            popup.classList.remove('open');
            document.getElementById('plant-counter-info')?.setAttribute('aria-expanded', 'false');
        });
    }

    initGlobalEvents() {
        this.container.addEventListener('click', (e) => {
            const target = e.target;
            // 📦 Add Meal
            const addBtn = target.closest('.add-btn');
            if (addBtn) {
                const variantId = addBtn.dataset.variantId;
                const inProductsExtras = addBtn.closest('.products-extras') !== null;
                
               
                if(document.querySelector('.pop-up_product.show')){
                    document.querySelector('.pop-up_product.show').classList.remove('show');
                    document.body.classList.remove('product-popup-open');
                }
   
                if (inProductsExtras) {
                    this.biondMealGlobalInterface.addExtra(variantId);
                }else{
                    this.biondMealGlobalInterface.addMeal(variantId);
                    
                }
                
                return;
            }

            // 🌱 Pflanzenzähler-Popup umschalten (Mobile: Klick, Desktop: Hover per CSS)
            const plantInfoBtn = target.closest('#plant-counter-info');
            if (plantInfoBtn) {
                const popup = document.getElementById('plant-counter-popup');
                const isOpen = popup?.classList.toggle('open');
                plantInfoBtn.setAttribute('aria-expanded', String(!!isOpen));
                return;
            }

            // 🌱 Pflanzenzähler-Popup schließen
            const plantCloseBtn = target.closest('#plant-counter-popup-close');
            if (plantCloseBtn) {
                document.getElementById('plant-counter-popup')?.classList.remove('open');
                document.getElementById('plant-counter-info')?.setAttribute('aria-expanded', 'false');
                return;
            }

            // ➕ Increase Quantity
            const plusBtn = target.closest('.plus-button');
            if (plusBtn) {
                const mealId = plusBtn.dataset.mealId;
                /*const productElement = document.querySelector(`.product-item[data-variant="${mealId}"]`);
                // Find mealData only if not in selected list to populate full info
                const existingMeal = this.biondMealGlobalInterface.selectedMeals.find(m => m.variantId === mealId);

                if (existingMeal) {
                    this.biondMealGlobalInterface.addMeal(mealId, existingMeal); // Use existing data to avoid DOM query for every click
                } else if (productElement) {
                    const mealData = this.biondMealGlobalInterface.extractMealDataFromElement(productElement);
                    
                }*/
                const inProductsExtras = plusBtn.closest('.box-item-extra') !== null;
               
                if (inProductsExtras) {
                    this.biondMealGlobalInterface.addExtra(mealId);
                }else{
                    this.biondMealGlobalInterface.addMeal(mealId);
                }
                return;
            }

            // ➖ Decrease Quantity
            const minusBtn = target.closest('.minus-button');
            if (minusBtn) {
                const mealId = minusBtn.dataset.mealId;
                
                const inProductsExtras = minusBtn.closest('.box-item-extra') !== null;
               
                if (inProductsExtras) {
                    this.biondMealGlobalInterface.removeExtra(mealId);
                }else{
                    this.biondMealGlobalInterface.removeMeal(mealId);
                }
                

                return;
            }

            // 🔍 Popup öffnen
            const popupTrigger = target.closest('.more-btn, .product-img');
            if (popupTrigger) {
                const productItem = popupTrigger.closest('.product-item');
                if (!productItem) return;

                const id = productItem.getAttribute('data-id');
                const popup = document.querySelector(`.pop-up_product[data-id="${id}"]`);
                if (!popup) return;

                popup.classList.add('show');
                document.body.classList.add('product-popup-open');

                const gallery = popup.querySelector('.product-gallery');
                // The Swiper initialization logic is correct as it checks for 'swiper-initialized'
                // and only initializes if the class is not present, fulfilling the requirement.
                if (gallery && !gallery.classList.contains('swiper-initialized')) {
                    new Swiper(gallery, {
                        loop: true,
                        slidesPerView: 'auto',
                        pagination: {
                            el: gallery.querySelector('.swiper-pagination'),
                            clickable: true,
                        },
                    });
                    gallery.classList.add('swiper-initialized');
                }
                return;
            }

            // ❌ Popup schließen
            const closeBtn = target.closest('.close-button');
            if (closeBtn) {
                const popup = closeBtn.closest('.pop-up_product');
                if (popup) {
                    popup.classList.remove('show');
                    document.body.classList.remove('product-popup-open');
                }
                return;
            }
            // ❌ Alert schließen
            const alertCloseBtn = target.closest('.custom-alert-close-button');
            if (alertCloseBtn) {
                this.biondMealGlobalInterface.alertBox.classList.remove('show'); 
                return;
            }

            
            // 💾 Save Meals
            const saveBtn = target.closest('#main-action-button');
            if (saveBtn) {
                if(this.biondMealGlobalInterface.isQuiz){
                    this.container.classList.add('show-buy-step');
                }else{
                    this.biondInterface.saveMeals();
                }
                
                return;
            }

            // 🔽 Accordion
            const accordionBtn = target.closest('.accordion-btn');
            if (accordionBtn) {
                const item = accordionBtn.closest('.accordion-item');
                item?.classList.toggle('active');
                return;
            }
            // 🔽 Dietary Filter open
            /*const dietaryFilter = target.closest('#dietary-preference');
            if (dietaryFilter) {
                const dietaryWrap = dietaryFilter.closest('.dietary-filter');
                dietaryWrap?.classList.toggle('active');
                return;
            }*/
            const selectedMealAbo = target.closest('.selected-meal-abo');
            if (selectedMealAbo) {
                selectedMealAbo?.classList.toggle('active');
                return;
            }
            const viewBoxBtn = target.closest('.view_box-btn');
            if (viewBoxBtn) {
                target.closest('.box-wrap')?.classList.toggle('active');
                return;
            }
            // 🔽 Dietary Filter select
            /*const dietaryFilterItem = target.closest('.filter-params-wrap .filter-item');
            if (dietaryFilterItem) {
                setTimeout(() => {
                    
                    // Alle aktivierten Checkboxen holen
                    const checkedBoxes = this.container.querySelectorAll('.filter-params-wrap .filter-item input[type="checkbox"]:checked');

                    // Labels für die Anzeige
                    const selectedLabels = Array.from(checkedBoxes).map(checkbox => {
                        const label = checkbox.nextElementSibling;
                        return label?.querySelector('.filter')?.textContent.trim();
                    }).filter(Boolean);

                    // Werte für activeIds.preferences
                    const selectedValues = Array.from(checkedBoxes).map(cb => cb.value);

                    // In UI anzeigen
                    const preferenceDisplay = document.getElementById('dietary-preference');
                    if (preferenceDisplay) {
                        preferenceDisplay.textContent = selectedLabels.join(', ') || '–';
                    }

                    // 🔁 In activeIds zurückschreiben
                    //this.biondInterface.activeIds.preferences = selectedValues;
                    //this.biondInterface.preferenceIds = selectedValues;

                    this.biondMealGlobalInterface.preferenceIds = selectedValues;

                    const dietaryWrap = dietaryFilterItem.closest('.dietary-filter');
                    dietaryWrap?.classList.toggle('active');
                    this.biondMealGlobalInterface.getProducts(false);
                    if(this.biondMealGlobalInterface.isQuiz){
                        this.biondMealGlobalInterface.updateUrl();
                    }


                }, 0);

                
                return;
            }*/
            const dietaryFilterItem = target.closest('.filter-preferences label');
            if (dietaryFilterItem) {
                setTimeout(() => {
                    const checkedBoxes = this.container.querySelectorAll('.filter-preferences input[type="checkbox"]:checked');

                    // Labels für die Anzeige
                    const selectedLabels = Array.from(checkedBoxes).map(checkbox => {
                        const label = checkbox.nextElementSibling;
                        return label?.querySelector('.filter-quiz-name')?.textContent.trim();
                    }).filter(Boolean);
                    const selectedValues = Array.from(checkedBoxes).map(cb => cb.value);
                    const preferenceDisplay = document.querySelector('.filter-preferences .selected-filter-quiz');
                    if (preferenceDisplay) {
                        preferenceDisplay.textContent = selectedLabels.join(', ') || 'Präferenzen';
                    }
                    
                    this.biondMealGlobalInterface.preferenceIds = selectedValues;
                    this.biondMealGlobalInterface.getProducts(false);
                    this.biondMealGlobalInterface.renderPlantCounter();
                    if(this.biondMealGlobalInterface.isQuiz){
                        this.biondMealGlobalInterface.updateUrl();
                    }
                }, 0);
            }
        });
        document.addEventListener('click', (event) => {
            const dietaryFilterEl = document.querySelector('#dietary-preference');
            const mealAboEls = document.querySelectorAll('.selected-meal-abo');

            const clickedInsideDietary = dietaryFilterEl?.contains(event.target);
            const clickedInsideMealAbo = Array.from(mealAboEls).some(el => el.contains(event.target));

            // Wenn außerhalb von #dietary-preference geklickt wurde → schließe dietary-filter
            if (!clickedInsideDietary) {
                document.querySelectorAll('.dietary-filter.active').forEach(el => el.classList.remove('active'));
            }

            // Wenn außerhalb von .selected-meal-abo geklickt wurde → schließe selected-meal-abo
            if (!clickedInsideMealAbo) {
                document.querySelectorAll('.selected-meal-abo.active').forEach(el => el.classList.remove('active'));
            }
        });
         document.querySelectorAll(".selected-filter-quiz").forEach(trigger => {
            trigger.addEventListener("click", function(e) {
                e.stopPropagation();

                const parent = this.closest(".custom-filter-quiz");

                // alle anderen Dropdowns schließen
                document.querySelectorAll(".custom-filter-quiz.active-dropdown").forEach(dropdown => {
                if (dropdown !== parent) {
                    dropdown.classList.remove("active-dropdown");
                }
                });

                // aktuelles Dropdown toggeln
                parent.classList.toggle("active-dropdown");
            });
            });

            // Globaler Klick-Listener zum Schließen, wenn außerhalb geklickt wird
            document.addEventListener("click", function(e) {
            document.querySelectorAll(".custom-filter-quiz.active-dropdown").forEach(dropdown => {
                if (!dropdown.contains(e.target)) {
                dropdown.classList.remove("active-dropdown");
                }
            });
        });
    }







    
}